import React, { useState } from "react";
import { Button, Checkbox, Control, Delete, Field, Input } from "@allxsmith/bestax-bulma";
import {getPartCustomerCost, getPartCustomerEstimatedCost} from "../../utils";
import { AsyncTypeahead} from "react-bootstrap-typeahead";
import axios from "axios";
import useEditableTableDateCell from "../../hooks/useEditableTableDateCell";

function Part({
  part,
  index,
  customer,
  updateParts,
  removePart,
  onSearchPartClick,
  appDefaults,
  work,
  disabled
}) {
  const [isLoading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [, setTypeahead] = useState();

  const handleChange = e => {
    const newPart = getNewPart(e);
    updateParts(newPart, index);
  };

  const onCheck = prop => {
    let newPart = { ...part, [prop]: !part[prop] };

    if (prop === "cost_override" && newPart[prop] === false) {
      newPart.customer_cost = getPartCustomerCost(newPart, customer, appDefaults);
      newPart.estimated_customer_cost = getPartCustomerEstimatedCost(newPart, customer, appDefaults)
    }

    updateParts(newPart, index);
  };

  const onSearch = e => {
    onSearchPartClick(part, index);
  };

  const getNewPart = e => {
    let newPart = { ...part, [e.target.name]: e.target.value };

    if (e.target.name === "cost") {
      newPart.customer_cost = getPartCustomerCost(newPart, customer, appDefaults);
    } else if (
      e.target.name === "estimated_cost"
    ) {
      newPart.estimated_cost = e.target.value;
      newPart.estimated_customer_cost = getPartCustomerEstimatedCost(newPart, customer, appDefaults);
      newPart.customer_cost = newPart.estimated_customer_cost;
      newPart.cost = newPart.estimated_cost;
    } else if (e.target.name === "estimated_customer_cost") {
      newPart.customer_cost = newPart.estimated_customer_cost;
    }

    return newPart;
  };

  const handleSearch = e => {
    setLoading(true);
    axios.get(`/api/contacts?contact_type=SP&search=${e}`).then(resp => {
      setSearchData(resp.data.results);
      setLoading(false);
    });
  };

  const handlePartSupplierSelect = supplier => {
    let newPart = { ...part, supplier: supplier[0] };
    updateParts(newPart, index);
  };

  return (
    <tr>
      <td>
        <Field className="has-addons">
          <Control>
            <Input
              type="text"
              value={part.name}
              name="name"
              onChange={handleChange}
              data-testid="part-name"
              disabled={disabled}
            />
          </Control>
          <Control>
            <Button
              data-testid="search-button"
              color="success"
              onClick={onSearch}
              disabled={disabled}
            >
              S
            </Button>
          </Control>
        </Field>
      </td>
      <td>
        <Control>
          <Input
            data-testid="est-cost-input"
            className="input"
            type="number"
            value={String(part.estimated_cost)}
            name="estimated_cost"
            onChange={handleChange}
            disabled={disabled}
          />
        </Control>
      </td>
      <td>
        <Control>
          <Input
            type="number"
            name="estimated_customer_cost"
            onChange={handleChange}
            value={String(part.estimated_customer_cost)}
            disabled={disabled}
          />
        </Control>
      </td>
      <td>
        <Control>
          <AsyncTypeahead
            useCache={false}
            id="typeahead"
            labelKey="display_name"
            minLength={2}
            name={"supplier"}
            onSearch={handleSearch}
            onChange={handlePartSupplierSelect}
            placeholder={"Search Supplier"}
            options={searchData}
            ref={typeahead => setTypeahead(typeahead)}
            className="typeahead"
            isLoading={isLoading}
            selected={part.supplier && part.supplier.id ? [part.supplier] : []}
            disabled={disabled}
          />
        </Control>
      </td>
      <td>
        <Control>
          <Input
            type="text"
            value={part.part_number}
            name="part_number"
            onChange={handleChange}
            disabled={disabled}
          />
        </Control>
      </td>
      <td>
        <Control>
          <Input
            type="text"
            value={part.part_invoice_number}
            name="part_invoice_number"
            readOnly
            disabled
          />
        </Control>
      </td>
      <td>
        <Control>
          <Input
            data-testid="cost-input"
            className="input"
            type="number"
            value={String(part.cost)}
            name="cost"
            disabled={true}
          />
        </Control>
      </td>
      <td>
        <Control>
          <Input
            type="number"
            name="customer_cost"
            value={String(part.customer_cost)}
            checked={part.customer_cost}
            disabled={true}
          />
        </Control>
      </td>
      <td>
        <Control>
          <Checkbox
            name="is_postage"
            checked={part.is_postage}
            onChange={() => onCheck("is_postage")}
            disabled={work.not_being_done}
          />
        </Control>
      </td>
      <td>
        <Control>
          <Checkbox
            type="checkbox"
            name="from_stock"
            checked={part.from_stock}
            disabled
            readOnly
          />
        </Control>
      </td>
      {useEditableTableDateCell({
            propName: "backorder_expected_date",
            value: part.backorder_expected_date,
            onChange: handleChange,
            editable: true,
            inlineEdit: false
      })}
      <td>
        <Control>
          <Checkbox
            type="checkbox"
            name="to_be_ordered"
            onChange={() => onCheck("to_be_ordered")}
            checked={part.to_be_ordered}
            disabled={work.not_being_done}
          />
        </Control>
      </td>
      <td>
        <Delete onClick={() => removePart(index, part)} data-testid="remove-part">
          Remove
        </Delete>
      </td>
    </tr>
  );
}
export default Part;
